import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { ShareNetwork } from 'vue-social-sharing'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toast-notification'


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialShare',
  props: {
    imageSize: { default: 30 },
    iconSizes: {},
    link: {},
    title: {},
    classes: {},
    isShowCopy: { type: Boolean, default: true },
    mainSocials: { default: () => ['telegram', 'viber', 'whatsapp', 'messenger'] },
    additionalSocials: { default: () => ['facebook', 'linkedin', 'skype'] }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const { t } = useI18n()
const $toast = useToast()

function copiedCallback(result: boolean) {
  if (result) {
    $toast.success(t('Link copied!'))
  } else {
    $toast.success(t('Something went wrong.'))
  }
}
const props = __props
const defaultImgAttributes = (social: string) => ({
  width: props.imageSize,
  height: props.imageSize,
  loading: 'lazy',
  decoding: 'async',
  alt: `${social} logo`,
})

const SOCIALS_MAP = {
  telegram: 'telegram',
  messenger: 'messenger',
  viber: 'viber',
  whatsapp: 'whatsapp',
  facebook: 'facebook',
  linkedin: 'linkedin',
  skype: 'skype',
  twitter: 'twitter',
  email: 'email',
}

const facebookAppId = window?.CONFIG?.FACEBOOK_APP_ID
const shareMessengerLink = ref<string>(
  `https://www.facebook.com/dialog/send?app_id=${facebookAppId}&link=${props.link}&redirect_uri=${window.location.href}`
)

const isMobileDeviceType = ref(navigator.maxTouchPoints > 0)

// isMobileDeviceType.value = !navigator.userAgent || (!!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

async function navigatorShare() {
  try {
    await navigator.share({
      url: props.link,
      title: props.title,
      text: props?.description || '',
    })
  } catch {
    isMobileDeviceType.value = false
  }
}

const __returned__ = { t, $toast, copiedCallback, props, defaultImgAttributes, SOCIALS_MAP, facebookAppId, shareMessengerLink, isMobileDeviceType, navigatorShare, ref, get ShareNetwork() { return ShareNetwork }, get useI18n() { return useI18n }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})